import React from 'react';

import UserIconList from 'components/user_icon_list';

interface Props {
  assignee?: { name: string };
}

export default function Assignee({ assignee }: Props) {
  return (
    <div className="d-flex align-items-center gap-1">
      <UserIconList
        users={assignee ? [assignee] : [{ imageUrl: '/images/default-profile-photo.png', name: 'Unassigned' }]}
      />
      <div>{assignee?.name || 'Unassigned'}</div>
    </div>
  );
}
